<template lang="">
	<div class="dashboard">
		<div>
      <h3 class="pt-15 text-h4 font-weight-bold">Bem-vindo ao Dashboard Gambit</h3>
      <p style="marginBottom: 80px;">Ferramenta usada para fazer disparos em SMS ou push notification para os usuários da área logada.</p>
    </div>

    <div class="cards" >
      <v-card v-for="(option, index) in options" :key="index" class="card d-flex flex-column">
        <a
          v-if="option.openMigrationModal"
          href="#"
          class="d-flex align-center justify-center flex-column pt-sm-7"
          @click.prevent="migrationDialog = true"
        >
          <i class="" :class="option.icon" />
          <h4 class="color mt-sm-2">{{option.title}}</h4>
          <p class="color">{{option.subtitle}}</p>
        </a>
        <router-link
          v-else
          :to="option.route"
          class="d-flex align-center justify-center flex-column pt-sm-7"
        >
          <i class="" :class="option.icon" />
          <h4 class="color mt-sm-2">{{option.title}}</h4>
          <p class="color">{{option.subtitle}}</p>
        </router-link>
      </v-card>
    </div>

    <UrlToolsMigrationModal v-model="migrationDialog" />
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import VueCookies from 'vue-cookies'
import UrlToolsMigrationModal from '@/components/Contents/UrlTools/UrlToolsMigrationModal.vue'

export default {
  components: {
    UrlToolsMigrationModal,
  },
  async created () {
    const token = VueCookies.get('jwt-login')
    await this.getRoles(token)
  },
	data () {
    return {
      migrationDialog: false,
      options: [
        { id: 1, icon: 'icon icon-sms', route: '/envio-mensagem', title: 'SMS e Push App', subtitle: 'Enviar notificações por SMS ou pelo App', roles: ["ANALYST", "ADMIN", "ROOT"]},
        { id: 2, icon: 'icon icon-list', route: '/lista-de-envios', title: 'SMS e Push App', subtitle: 'Lista de envio por SMS', roles: ["ANALYST", "ADMIN", "ROOT"]},
        { id: 4, icon: 'icon icon-global', openMigrationModal: true, title: 'Ferramentas de URL', subtitle: 'Ferramentas de auxílio e tratamento de URL.', roles: ["ANALYST", "ADMIN", "ROOT"] },
        { id: 5, icon: 'icon icon-calendar', route: '/agendamentos', title: 'Agendamentos', subtitle: 'Agendamentos de Push Web', roles: ["ANALYST", "ADMIN", "ROOT"]},
        { id: 6, icon: 'icon icon-calendar', route: '/scheduling-web', title: 'Agendamentos', subtitle: 'Agendamentos de SMS e Push App', roles: ["ANALYST", "ADMIN", "ROOT"]},
        { id: 7, icon: 'icon icon-global', openMigrationModal: true, title: 'Teste AB', subtitle: 'Gerador de links para os testes', roles: ["ADMIN", "ANALYST", "ROOT", "SHORTNER_CUSTOM", "SHORTNER_UPDATE",
          "WEB_PUSH_NOTIFICATION_API", "WEB_PUSH_NOTIFICATION_APP", "MANYCHAT", "MANYCHAT_ADMIN", "MANYCHAT_USER"],
        },
        { id: 8, icon: 'icon icon-clock', route: '/disparos-automaticos', title: 'Disparos Automáticos', subtitle: 'Automatização de Disparos', roles: ["EMAIL_COMUNICATION_API", "ADMIN", "ROOT"]},
        { id: 9, icon: 'icon icon-facebook', route: '/facebook', title: 'Formulário', subtitle: 'Novo formulário', roles: ["EMAIL_COMUNICATION_API", "ADMIN", "ROOT"]},
      ],
    }
  },
  computed: {
    ...mapState('Users', {
      rolesUser: 'rolesUser'
    }),
  },
  methods: {
    ...mapActions("Users", ["getRoles"]),
  },
}
</script>
<style lang="">

.dashboard {
  margin-left: 184px;
  height: 100vh;
}

.cards a {
  text-decoration: none;
  height: 100%;
}

.color, .icon {
  color: var(--black);
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  Width: 44px;
  padding: 10px;
  background: var(--grey-day-020) !important;
  border-radius: 50%;
  height: 44px;
  font-size: 22px;
}

.card {
  width: 386px;
  height: 171px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;
  grid-auto-flow: row
}

@media screen and (max-width: 1377px) {
  .dashboard {
    margin-left: 120px;
  }

  .cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    grid-auto-flow: row
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/Dashboard/DashboardView.vue